import React, { useEffect, useState } from "react";
import { FaEye, FaEyeSlash, FaArrowLeft } from "react-icons/fa";
import { leftArrow } from "../../common/Assets/imgs";
import { useLocation, useNavigate } from "react-router-dom";
import Header from "../../Components/Header";
import { get, post, put } from "../../Services/ApiHandler";
import toast from "react-hot-toast";
import { BASE_URL, URLS } from "../../Services/Constant";

const AddAdmin = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const navigation = useNavigate();
  const location = useLocation();
  const [isEdit, setIsEdit] = useState(false);
  // const data = location?.state?.data || {};
  const [isLoading, setIsLoading] = useState(false);
  const { data = null, type = "add" } = location.state || {};
  console.log("mmmvcv", data);
  const [adminList, setAdminList] = useState([]);
  const [rolesLoaded, setRolesLoaded] = useState(false);

  const role = [
    { id: 1, name: "superAdmin" },
    { id: 2, name: "Admin" },
    // {id:3,name:'super'},
  ];

  // const type = location?.state?.type || {};
  const [form, setForm] = useState({
    adminId: "",
    name: "",
    role: "",
    email: "",
    mobile: "",
    password: "",
    confirmPassword: "",
  });

  const handleChange = (key, value) => {
    setForm({ ...form, [key]: value });
  };

  const getList = async (src) => {
    try {
      const res = await get(`${URLS.ROLES_LIST}`);
      console.log("res", res);
      if (res?.status === "success") {
        const ActiveRoles = res?.data.filter((i) => i.status === true);
        setAdminList(ActiveRoles);
        setRolesLoaded(true);
      }
    }
    catch (err) {
      console.log('err', err);
    }
  }

  useEffect(() => {
    getList();
  }, [])

  const normalizeRoleValue = (rawRole) => {
    if (!rawRole) return "";

    const role = adminList.find(
      (item) => item.name.toLowerCase() === rawRole.toLowerCase()
    );

    // Return id for select value, fallback to rawRole if already id
    return role?.id || rawRole || "";
  };

  useEffect(() => {
    if (type === "edit" || type === "view") {
      setForm({
        adminId: data?.admin_code || "",
        name: data?.name || "",
        role: normalizeRoleValue(data?.role),
        email: data?.email || "",
        mobile: data?.mobile || "",
        password: "",
        confirmPassword: "",
      });
    } else {
      // ADD mode → reset form
      setForm({
        adminId: "",
        name: "",
        role: "",
        email: "",
        mobile: "",
        password: "",
        confirmPassword: "",
      });
    }
    if (type === "view") {
      setIsEdit(false);
    } else {
      setIsEdit(true);
    }
  }, [data, type, adminList]);

  const handleSave = async () => {
    console.log("");

    const trimmed = {
      name: form.name.trim(),
      role: String(form.role).trim(),
      email: form.email.trim(),
      mobile: form.mobile.trim(),
      password: form.password,
      confirmPassword: form.confirmPassword,
    };

    // ✅ Required field validation
    if (!trimmed.name) {
      toast.error("Admin name is required");
      return;
    }
    if (!trimmed.role) {
      toast.error("Role is required");
      return;
    }
    if (!trimmed.email) {
      toast.error("Email is required");
      return;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmed.email)) {
      toast.error("Please enter a valid email");
      return;
    }
    if (!trimmed.mobile) {
      toast.error("Mobile number is required");
      return;
    }

    // ✅ Mobile validation
    if (!/^[0-9]{10}$/.test(trimmed.mobile)) {
      toast.error("Mobile number must be exactly 10 digits");
      return;
    }

    const isAdd = type === "add";
    const wantsPassword =
      trimmed.password.length > 0 || trimmed.confirmPassword.length > 0;

    if (isAdd || wantsPassword) {
      if (!trimmed.password) {
        toast.error("Password is required");
        return;
      }
      if (!trimmed.confirmPassword) {
        toast.error("Confirm password is required");
        return;
      }
      if (trimmed.password.length < 6) {
        toast.error("Password must be at least 6 characters");
        return;
      }
      if (trimmed.password !== trimmed.confirmPassword) {
        toast.error("Passwords do not match");
        return;
      }
    }

    const payload = {
      // admin_id: form.adminId,
      name: trimmed.name,
      role: trimmed.role,
      email: trimmed.email,
      mobile: trimmed.mobile,
      ...((isAdd || wantsPassword) && { password: trimmed.password }),
    };
    console.log("payload", payload);
    if (type === "add") {
      setIsLoading(true);
      try {
        const res = await post(URLS.ADMIN_VIEW, payload);

        console.log("");
        if (res?.status === "success") {
          toast.success(res.message || "Success");
          setIsLoading(false);
          navigation(-1);
        }
      } catch (err) {
        console.log("err", err);
        setIsLoading(false);
      } finally {
        setIsLoading(false);
      }
    } else {
      console.log("data.id", data.id);
      setIsLoading(true);
      try {
        const res = await put(`${URLS.ADMINS}${data.id}/`, payload);
        console.log("");
        if (res?.status === "success") {
          toast.success(res.message || "Success");
          navigation(-1);
        }
      } catch (err) {
        console.log("err", err);
      } finally {
        setIsLoading(false);
      }
    }
  };

  return (
    <div>
      <Header />
      <div className="add-admin-container">
        {/* Header */}
        <div onClick={() => navigation(-1)} className="admin-header">
          <img src={leftArrow} className="back-icon-arrow" />
          <h2>Admin</h2>
        </div>

        {/* Form */}
        <div className="admin-form">
          {/* Row 1 */}
          {/* <div className="form-groups">
            <label>Admin ID</label>
            <input
              type="text"
              value={form.adminId}
              onChange={(e) => handleChange("adminId", e.target.value)}
              readOnly={!isEdit}
            />
          </div> */}

          <div className="form-groups">
            <label>Admin Name</label>
            <input
              type="text"
              value={form.name}
              placeholder="Enter Admin Name"
              onChange={(e) => handleChange("name", e.target.value)}
              readOnly={!isEdit}
            />
          </div>

          {/* Row 2 */}
          <div className="form-groups">
            <label>Role</label>
            {/* <input
              type="text"
              value={form.role}
              onChange={(e) => handleChange("role", e.target.value)}
              readOnly={!isEdit}
            /> */}
            <select
              value={form.role}
              onChange={(e) => handleChange("role", e.target.value)}
              disabled={!isEdit || (type !== "add" && !rolesLoaded)}
            >
              <option value="">Select Role</option>
              {adminList?.map((it, inx) => (
                <option key={inx} value={it?.id}>{it?.name}</option>
              ))}
            </select>
          </div>

          <div className="form-groups">
            <label>Email ID</label>
            <input
              type="email"
              value={form.email}
              placeholder="Enter mail ID"
              onChange={(e) => handleChange("email", e.target.value)}
              readOnly={!isEdit}
            />
          </div>

          {/* Row 3 */}
          <div className="form-groups">
            <label>Mobile Number</label>
            <input
              type="text"
              maxLength={10}
              placeholder="Enter mobile number"
              value={form.mobile}
              // onChange={(e) => {
              //   const value = e.target.value.replace(/\D/g, ""); // allow only digits
              //   handleChange("mobile", value);
              // }}
              onChange={(e) => {
                const value = e.target.value.replace(/\D/g, ""); // only digits
                if (value.length <= 10) {
                  handleChange("mobile", value);
                }
              }}
              readOnly={!isEdit}
            />
          </div>

          <div className="form-groups password-field">
            <label>Password</label>
            <div className="input-with-icon">
              <input
                type={showPassword ? "text" : "password"}
                value={form.password}
                placeholder="Enter password"
                onChange={(e) => handleChange("password", e.target.value)}
                readOnly={!isEdit}
              />
              <span onClick={() => setShowPassword(!showPassword)}>
                {showPassword ? <FaEye /> : <FaEyeSlash />}
              </span>
            </div>
          </div>

          {/* Row 4 */}
          <div className="form-groups password-field">
            <label>Confirm Password</label>
            <div className="input-with-icon">
              <input
                type={showConfirmPassword ? "text" : "password"}
                value={form.confirmPassword}
                placeholder="Enter password"
                onChange={(e) =>
                  handleChange("confirmPassword", e.target.value)
                }
                readOnly={!isEdit}
              />
              <span
                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
              >
                {showConfirmPassword ? <FaEye /> : <FaEyeSlash />}
              </span>
            </div>
          </div>
        </div>

        {/* Buttons */}
        <div className="admin-actions">
          {type === "view" && !isEdit && (
            <button onClick={() => setIsEdit(true)} className="edit-btn">
              Edit
            </button>
          )}
          {(type === "add" || isEdit) && (
            <button
              onClick={handleSave}
              className="save-btn"
              disabled={isLoading}
            >
              {isLoading ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                    style={{ color: "white", padding: 8 }}
                  ></span>
                </>
              ) : (
                "Save"
              )}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default AddAdmin;
